module.exports = __webpack_public_path__ + "img/bannedn.1670a543.png";